import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ditta',
  templateUrl: './ditta.component.html',
  styleUrls: ['./ditta.component.css']
})
export class DittaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
